import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import { Switch } from 'pretty-checkbox-react';
/* actions */
import { getAllDepartments } from '../../redux/actions/departments';
import { getAllDevices } from '../../redux/actions/devices';
import { addIVRs } from '../../redux/actions/ivrs';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/ivr';

function Add () {
  const INITIAL_VALUES = {
    name: '',
    department: '',
    deviceId: '',
    description: '',
    audio: {},
    waitsec: 0,
    saydigits: false
  };

  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema
  });
  const departments = useSelector(state => state.departments.data);
  const devices = useSelector(state =>
    state.devices.data
      .filter(device => device.type === 'G')
      .sort((a, b) =>
        a.number.toLowerCase().localeCompare(b.number.toLowerCase())
      )
  );
  const ivrs = useSelector(state => state.ivrs);
  const dispatch = useDispatch();
  const [data, setData] = useState(INITIAL_VALUES);
  const submitButton = useRef();
  const audioField = useRef();

  useEffect(() => {
    dispatch(getAllDepartments());
    dispatch(getAllDevices());
  }, [dispatch]);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
      audioField.current.setAttribute('src', '');
    };
    const newData = {
      ...data,
      deviceId: data.deviceId ? data.deviceId : null,
      waitsec: data.waitsec ? Number(data.waitsec) : 0
    };
    dispatch(addIVRs(newData, resetForm, submitButton.current));
  };

  const handleChange = evt => {
    evt.preventDefault();
    if (evt.target.getAttribute('number') === 'on') {
      if (evt.target.value.match(/^\d+$/) || evt.target.value === '') {
        setData({
          ...data,
          [evt.target.name]: evt.target.value
        });
      } else {
        evt.target.value = data[evt.target.name];
      }
    } else {
      const isCheckbox = evt.target.type === 'checkbox';
      setData({
        ...data,
        [evt.target.name]: isCheckbox ? evt.target.checked : evt.target.value
      });
    }
  };

  const handleChangeAudio = evt => {
    const { value, files, name } = evt.target;
    const tagAudio = audioField.current;
    const extesion = value.slice(-4).toLowerCase();
    if (extesion === '.wav' && files && files[0]) {
      const reader = new FileReader();
      reader.onload = e => {
        tagAudio.setAttribute('src', e.target.result);
      };
      reader.readAsDataURL(files[0]);
      setData({ ...data, [name]: files[0] });
    } else {
      tagAudio.setAttribute('src', '');
      setData({ ...data, [name]: {} });
    }
  };

  return (
    <div className="container-fluid">
      {ivrs.addSuccess && (
        <AlertMsg type="success" msg="URA cadastrada com sucesso" />
      )}
      {ivrs.errorContent &&
        !ivrs.errorContent.message.includes('400') &&
        ivrs.addError && (
        <AlertMsg type="danger" msg="Falha durante cadastro da URA" />
      )}
      {ivrs.errorContent &&
        ivrs.errorContent.message.includes('400') &&
        ivrs.addError && (
        <AlertMsg
          type="danger"
          msg="O grupo informado ou nome da URA já estão em uso"
        />
      )}
      {!ivrs.addSuccess && !ivrs.addError && (
        <AlertMsg type="info" msg="Área cadastro da URA" />
      )}
      <FormHeader title="Cadastrar URA" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="name">
                Nome<span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                autoComplete="off"
                onChange={handleChange}
                ref={register}
              />
              {errors.name && errors.name.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="department">
                Departamento<span className="field-required">*</span>
              </label>
              <select
                className="form-control"
                id="department"
                name="department"
                onChange={handleChange}
                ref={register}
              >
                <option value="">-- Selecione --</option>
                {departments.map((dpt, i) => {
                  const _id = dpt._id || Date.now() + '' + i;
                  return (
                    <option key={_id} value={_id}>
                      {dpt.name}
                    </option>
                  );
                })}
              </select>
              {errors.department && errors.department.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="waitsec">
                Tempo de Espera (Segundos)
                <span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="waitsec"
                name="waitsec"
                number="on"
                autoComplete="off"
                defaultValue={data.waitsec}
                onChange={handleChange}
                ref={register}
              />
              {errors.waitsec && errors.waitsec.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.waitsec && errors.waitsec.type === 'min' && (
                <ErrorMsgField
                  type="min"
                  msg="Valor mínimo permitido maior ou igual a 0"
                />
              )}
              {errors.waitsec && errors.waitsec.type === 'max' && (
                <ErrorMsgField
                  type="max"
                  msg="Valor máximo permitido menor ou igual a 10"
                />
              )}
              {errors.waitsec && errors.waitsec.type === 'typeError' && (
                <ErrorMsgField type="typeError" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="saydigits">
                Falar Dígitos<span className="field-required">*</span>
              </label>
              <div className="checkbox">
                <Switch
                  type="checkbox"
                  color="success"
                  name="saydigits"
                  onChange={evt => {
                    setData({
                      ...data,
                      [evt.target.name]: evt.target.checked
                    });
                  }}
                  checked={data.saydigits}
                >
                  {data.saydigits ? 'Ativado' : 'Desativado'}
                </Switch>
              </div>
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="deviceId">
            Grupo<span className="field-required">*</span>
          </label>
          <select
            className="form-control"
            id="deviceId"
            name="deviceId"
            onChange={handleChange}
            ref={register}
          >
            <option value="">-- Selecione --</option>
            {devices.map((dvc, i) => {
              const _id = dvc._id || Date.now() + '' + i;
              return (
                <option key={_id} value={_id}>
                  {dvc.number} | {dvc.name || '*'} - Dpto: {dvc.department.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="audio">
                Áudio&nbsp;
                <span className="badge badge-info align-text-top">
                  Codec Suportado WAV
                </span>
                <span className="field-required">*</span>
              </label>
              <input
                type="file"
                className="form-control-file"
                id="audio"
                name="audio"
                autoComplete="off"
                accept="audio/wav"
                onChange={handleChangeAudio}
                ref={register}
              />
              {errors.audio && errors.audio.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.audio && errors.audio.type === 'fileFormat' && (
                <ErrorMsgField type="fileFormat" />
              )}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="listen">Áudio Preview</label>
              <audio
                id="listen"
                name="listen"
                className="audio-preview"
                controls
                controlsList="nodownload"
                ref={audioField}
              ></audio>
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            onChange={handleChange}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <FormFooter url="/ivrs" reference={submitButton} />
      </form>
    </div>
  );
}

export default Add;
